import EmployeePerformanceComponents from "../components/EmployeePerformance";
import useEmployeePerformance from "../hooks/useEmployeePerformance";

function EmployeePerformance() {
  const employeePerformanceProps = useEmployeePerformance();
  return <EmployeePerformanceComponents {...employeePerformanceProps} />;
}

export default EmployeePerformance;
